import { formatDate, GeneralLedgerTransaction, formatBalance } from '@ui/src';

import cn from '../styles.module.css';

const formatGLList = ({
  list,
}: {
  list: GeneralLedgerTransaction[];
}): GeneralLedgerTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      currencyId: <div>{result?.currency.name || ''}</div>,
      debitAccountId: <div>{result?.debitAccount?.fullNumber || ''}</div>,
      creditAccountId: <div>{result?.creditAccount?.fullNumber || ''}</div>,
      debitAccount: <div>{result?.debitAccount?.description || ''}</div>,
      creditAccount: <div>{result?.creditAccount?.description || ''}</div>,
      sum: <div>{formatBalance(result.sum)}</div>,
      documentNumber: (
        <div className={`${cn.documentNumberRow} ${cn.documentInfoRow}`}>
          {result.documentNumber}
        </div>
      ),
      info: <div className={cn.documentInfoRow}>{result.info}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatGLList;
